import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpDateNotInPastValidator
     * @memberof app
     *
     * @restrict A
     * @scope false
     *
     * @description
     * If date is in the past, the value is invalid
     *
     * @attr {{start: Date, end: Date}} ngModel
     * @attr {boolean} dateNotInPastValidatorActive
     *
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive('pkpDateNotInPastValidator', pkpDateNotInPastValidator);

    function pkpDateNotInPastValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpDateNotInPastValidator = validate;

            function validate(modelValue) {
                if (!modelValue) {
                    return true;
                }

                if (
                    angular.isDefined(attr.dateNotInPastValidatorActive) &&
                    !scope.$eval(attr.dateNotInPastValidatorActive)
                ) {
                    return true;
                }

                var now = moment();
                var date = moment(modelValue);

                return !date.isBefore(now, 'minute');
            }

            scope.$watch(
                function () {
                    return scope.$eval(attr.dateNotInPastValidatorActive);
                },
                function () {
                    ngModelCtrl.$validate();
                }
            );
        }
    }
})();
